/* eslint-disable camelcase */
/* eslint-disable no-magic-numbers */

const url = new URL(window.location.href);
const pathSegments = url.pathname.split('/');
const formName = decodeURI(pathSegments[pathSegments.length - 1]);

const formObserver = new MutationObserver((mutationsList) => {
	mutationsList.forEach((mutation) => {
		if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
			const addedNode = mutation.addedNodes[0];
			if (addedNode && addedNode.id  && typeof addedNode.id === 'string' && addedNode.id.includes('app-embed')) {
				observeInitForm(addedNode);
				return;
			}
		} 
	});
});

formObserver.observe(document.body, { childList: true, subtree: true });

function observeInitForm(form) {
	const formContentContainer = form.shadowRoot.querySelector('div');
	const formData = formContentContainer.querySelector('form');
	
	const labels = formData.querySelectorAll('label');
	const fieldContainers = formData.querySelectorAll('._formFieldContainer_ck6wz_5');
	
	changeLabelToRtl(labels);
	fixFieldContainersRtl(fieldContainers);
	
	// Add phone validation before form submission to Shopify
	addPhoneValidationBeforeSubmit(formData);
	
	// Select the input element
	const observer = new MutationObserver((mutationsList) => {
		mutationsList.forEach((mutation) => {
			if (mutation.type === 'attributes' && mutation.attributeName === 'data-current-step') {
				const currentStep = mutation.target.getAttribute('data-current-step');
				if (currentStep === 'success') {
					setDataLayerObject(formData);
				}
			}
		});
	});

	observer.observe(formContentContainer, { attributes: true });
}

function changeLabelToRtl(labels) {
	labels.forEach((label) => {
		label.style.right = '15px';
		label.style.left = 'unset';
		label.style.textAlign = 'right';
		label.style.transformOrigin = 'right center';	
	});
}

function fixFieldContainersRtl(fieldContainers) {
	fieldContainers.forEach((container) => {
		const input = container.querySelector('input[inputmode="text"]');
		if (input) {
			container.style.textAlign = 'right';
		}
	});
}

function addPhoneValidationBeforeSubmit(formData) {
	const phoneInput = formData.querySelector('#phone_number');
	if (!phoneInput) return;
	
	formData.addEventListener('submit', (e) => {
		const phoneValue = phoneInput.value.replace(/[\s-]/g, '');
		
		if (phoneValue) {
			if (phoneValue.startsWith('972')) {
				phoneInput.value = '+' + phoneValue;
			} else if (!phoneValue.startsWith('+972') && !phoneValue.startsWith('+')) {
				phoneInput.value = '+972' + phoneValue;
			}
			
			phoneInput.dispatchEvent(new Event('input', { bubbles: true }));
			phoneInput.dispatchEvent(new Event('change', { bubbles: true }));
		}
	}, true);
}


function setDataLayerObject(formData) {
	const inputDate = (
		formData.querySelector('input._formInputField_237zm_7[aria-labelledby="YYYY"]') ||
		formData.querySelector('input._formInputField_237zm_7[aria-labelledby="label-YYYY"]')
	)?.value;
	const phoneNumberElement = formData.querySelector('#phone_number').value;
	let phoneNumber = phoneNumberElement.replace(/[\s-]/g, '');
	const email = formData.querySelector('#email');

	const dataLayerSucces = {
		event: 'generate_lead',
		eventInfo: {
			screen_name: url.href,
			user_action: 'submits_lead',
			form_name: formName ? formName : 'popup',
			email: email.value,
			phone_number: phoneNumber,
		},
	};
	// This Element is the product name in select tag
	const productName = formData.querySelector(
		'button[aria-controls="custom#experience-kit-selector-dropdown"] span._selectToggleText_1ujcz_25'
	);
	if (inputDate) {
		dataLayerSucces.eventInfo.birth_year = inputDate;
	}
	if (productName) {
		dataLayerSucces.eventInfo.selected_product = productName.innerText;
	}
	window.dataLayer.push(dataLayerSucces);
}
